var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9682 5.81455C15.3409 4.15508 14.2519 2.71997 12.8358 1.68659C11.4196 0.653212 9.73844 0.066858 8 0C6.26156 0.066858 4.58038 0.653212 3.16424 1.68659C1.7481 2.71997 0.659078 4.15508 0.031774 5.81455C-0.0105913 5.93439 -0.0105913 6.06561 0.031774 6.18545C0.659078 7.84492 1.7481 9.28003 3.16424 10.3134C4.58038 11.3468 6.26156 11.9331 8 12C9.73844 11.9331 11.4196 11.3468 12.8358 10.3134C14.2519 9.28003 15.3409 7.84492 15.9682 6.18545C16.0106 6.06561 16.0106 5.93439 15.9682 5.81455ZM8 9.54545C7.31434 9.54545 6.64408 9.33752 6.07397 8.94794C5.50386 8.55836 5.05952 8.00463 4.79713 7.35679C4.53474 6.70894 4.46608 5.99607 4.59985 5.30832C4.73361 4.62057 5.06379 3.98883 5.54863 3.49299C6.03346 2.99714 6.65118 2.65947 7.32367 2.52267C7.99615 2.38587 8.6932 2.45608 9.32667 2.72443C9.96014 2.99277 10.5016 3.4472 10.8825 4.03025C11.2634 4.6133 11.4668 5.29878 11.4668 6C11.4654 6.93987 11.0997 7.84083 10.4498 8.50542C9.79998 9.17001 8.91901 9.54401 8 9.54545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowicon);
export default __webpack_public_path__ + "static/media/showicon.5bc4c0d0f120258ec193e706ed503387.svg";
export { ForwardRef as ReactComponent };